import { Directive, inject } from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select';

// ng-select only focuses (never opens) on a press of a non-searchable select's selected value,
// and preventDefault stops the browser's focus move from blurring the select and closing the panel.
@Directive({
  selector: 'ng-select[appOpenOnValuePress]',
  host: { '(mousedown)': 'onMousedown($event)' },
})
export class OpenOnValuePressDirective {
  private readonly select = inject(NgSelectComponent, { self: true });

  onMousedown(event: MouseEvent): void {
    if (
      event.button !== 0 ||
      this.select.searchable() ||
      this.select.disabled()
    ) {
      return;
    }
    const target = event.target as HTMLElement;
    if (!target.closest('.ng-value') || target.closest('.ng-value-icon')) {
      return;
    }
    event.preventDefault();
    this.select.toggle();
  }
}
